<template>
  <f7-page>
    <template #fixed>
      <TheNavbar
        class="secondary-navbar"
        back-btn-enable
        :nav-title="t('common.settings')"
      />
    </template>

    <PCSettingsBlockContracts class="settings-block" />
    <PCSettingsBlockInformationBar class="settings-block" />
    <PCSettingsBlockSideNavbar class="settings-block" />
    <PCSettingsBlockPalletizingPoints class="settings-block" />
    <PCSettingsBlockInventoryRegularization class="setting-block" />
    <PCSettingsBlockExpeditions class="settings-block" />
    <PCSettingsBlockPicking class="settings-block" />
    <PCSettingsBlockReturnables class="settings-block" />
    <PCSettingsBlockInformation class="settings-block" />
  </f7-page>
</template>

<script setup>
// @ts-check
import { useI18n } from 'vue-i18n';

import TheNavbar from '@/components/TheNavbar.vue';
import PCSettingsBlockContracts from '@/components/settings/PCSettingsBlockContracts.vue';
import PCSettingsBlockInformationBar from '@/components/settings/PCSettingsBlockInformationBar.vue';
import PCSettingsBlockInventoryRegularization from '@/components/settings/PCSettingsBlockInventoryRegularization.vue';
import PCSettingsBlockSideNavbar from '@/components/settings/PCSettingsBlockSideNavbar.vue';
import PCSettingsBlockPalletizingPoints from '@/components/settings/PCSettingsBlockPalletizingPoints.vue';
import PCSettingsBlockInformation from '@/components/settings/PCSettingsBlockInformation.vue';
import PCSettingsBlockExpeditions from '@/components/settings/PCSettingsBlockExpeditions.vue';
import PCSettingsBlockPicking from '@/components/settings/PCSettingsBlockPicking.vue';
import PCSettingsBlockReturnables from '@/components/settings/PCSettingsBlockReturnables.vue';

const { t } = useI18n();
</script>

<style scoped lang="scss">
.settings-block {
  padding: var(--f7-typography-padding);
}
</style>
